export function isFlowV2Step(flowUUID: string | null | undefined, search: string): boolean {
	return !flowUUID && Boolean(new URLSearchParams(search).get('currentFlowMainOffer'));
}
